<template>
    <div class="notifications_push_wrapper">
        <transition-group name="list" tag="div" class="notification-animation">
            <Notes v-for="(item, index) in push_notifications_active"
                   v-if='view'
                   :key="`key-${index}`"
                   :note="item"
                   class="notitfications_push-snack"
                   @openHandler='openHandler'
            />
        </transition-group>
    </div>
</template>
<script>
import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
import Notes from './notifications_push';

export default {
  components: {
    Notes,
  },
  data() {
    return {
      delay: 10000,
      view : true,
    };
  },
  computed: {
    ...mapState('common', [
      'pageFocus',
    ]),
    ...mapGetters('notifications/Notifications_items', [
      'push_notifications_active',
      'push_notifications_active_count',
    ]),
  },
  watch: {
    push_notifications_active_count() {
      this.view = true;

      setTimeout(async () => {
        this.view = false;
      }, this.delay);
    },
  },
  async mounted() {
    if (this.$route.meta.requiresAuth) {
      this.view = true;

      setTimeout(async () => {
        await this.get_notifications();
      }, 1000);

      setTimeout(async () => {
        this.view = false;
      }, this.delay);

      /* setInterval(async () => {
        if (this.pageFocus) {
          await this.get_notifications();
        }
      }, 30000);*/
    }
  },
  methods: {
    openHandler() {
      this.view = false;
    },
    ...mapActions('notifications/Notifications_items', ['get_notifications']),
    ...mapMutations('notifications/Notifications_items', ['SET_PUSH_NOTIFICATIONS', 'DELETE_READ_NOTE']),
    ...mapActions('notifications/Notifications_items', ['check_push_notifications', 'set_read_note']),
  },
};
</script>

<style>
.list-enter-active, .list-leave-active {
  transition: all 1.3s;
}

.list-enter{
  opacity: 0!important;
  transform: translateY(100px);
}

.list-leave-to {
  transform: translateX(150%);
  opacity: 0!important;
}
</style>
